/*
 * @Author: Teemo Ding
 * @Date: 2021-06-23 15:42:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-24 13:29:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/StoreDetails/Components/Label/index.tsx
 */

import React, { ReactNode } from 'react';
import { Form } from 'antd';
import CountWords from '@/src/components/CountWords/CountWords';
import css from './css.module.less';
interface labelProps {
  title: string;
  rightPart?: string | ReactNode;
  rightSubTitle?: string;
  bottomTitle?: string;
  titleContainerClassName?: string;
  bottomTitleContainerClassName?: string;
  textLength?: number;
  nameKey?: string;
}

const label = ({
  title,
  rightPart,
  rightSubTitle,
  bottomTitle,
  titleContainerClassName,
  bottomTitleContainerClassName,
  textLength,
  nameKey,
}: labelProps) => (
  <div className={`${css.titleContainer} ${titleContainerClassName || ''}`}>
    <div className={css.mainTitleContainer}>
      <div className={css.upperTitleContainer}>
        {title && <div className={css.title}>{title}</div>}

        {rightSubTitle && (
          <div className={css.rightSubTitle}>{rightSubTitle}</div>
        )}
      </div>
      {bottomTitle && (
        <div
          className={
            css.bottomTitleContainer + ' ' + bottomTitleContainerClassName || ''
          }>
          {bottomTitle}
        </div>
      )}
    </div>
    {textLength && nameKey && (
      <Form.Item
        className={css.noMargin}
        shouldUpdate={(prevValues, curValues) =>
          prevValues[nameKey] !== curValues[nameKey]
        }>
        {({ getFieldValue }) => {
          const value = getFieldValue(nameKey);
          return (
            <CountWords count={(value || '').length} allCount={textLength} />
          );
        }}
      </Form.Item>
    )}
  </div>
);

export default label;
